import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface UploadState {
  status: Record<string, boolean>
}

const initialState: UploadState = {
  status: {},
}

const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {
    startUpload: (state, action: PayloadAction<string>) => {
      const id = action.payload
      state.status[id] = false
    },
    finishUpload: (state, action: PayloadAction<string>) => {
      const id = action.payload
      state.status[id] = true
    },
    resetUpload: (state, action: PayloadAction<string>) => {
      delete state.status[action.payload]
    },
    clearAllUpload: (state) => {
      state.status = {}
    },
  },
})

export const { startUpload, finishUpload, resetUpload, clearAllUpload } =
  uploadSlice.actions

export default uploadSlice.reducer
